import {http} from '../../axios'
import store from '../index'

export default {
  namespaced: true,
  state: {
    pending: false,
    loaded: false,
    pageData: {}
  },
  getters: {},
  mutations: {
    setProperty(store, [key, value]) {
      store[key] = value
    },
    reset(state) {
      state.loaded = false
      state.pageData = {}
    }
  },
  // https://classic.devseonet.com/api/feedback/vacancies?lang=uk
  actions: {
    load({state, commit}, id) {
      commit('reset')
      if (state.loaded || state.pending) return
      commit('setProperty', ['pending', true])

      http.get('/api/page/one', {
        params: {
          page_id: id
        }
      })
        .then(({data}) => {
          commit('setProperty', ['pageData', data.page])
          if (state.pageData.facebook) {
            store.commit('footerSocials/setProperty', ['facebook', state.pageData.facebook]);
          }
          if (state.pageData.instagram) {
            store.commit('footerSocials/setProperty', ['instagram', state.pageData.instagram]);
          }
          if (state.pageData.youtube) {
            store.commit('footerSocials/setProperty', ['youtube', state.pageData.youtube]);
          }
          commit('setProperty', ['loaded', true])
        })
        .finally(() => {
          commit('setProperty', ['pending', false])
        })
    }
  }
}
